import HttpMethods from '../enums/HttpMethods'
import WebService from './WebService'
import {getFormattedDate} from "../utils/DateUtils";
import {getFormattedTime} from "../utils/DateUtils";
import FileSaver from "file-saver";
import {getCookie} from "../utils/CookieUtils";

class TransactionService {

    getTransactionList(page, size, sort,
                       merchantCountry, company, society, store,
                       activity, status,
                       idTransaction, idOrder,
                       paymentMode, paymentType,
                       cardCategory, cardType,
                       startDate, endDate, startSettDate, endSettDate, type) {

        let url = '/api/transactions?page=' + page + '&size=' + size;
        if (!sort.columns || sort.columns === 'DATE') {
            const order = sort.order ? sort.order : 'asc'
            url += "&sort=date," + order + "&sort=hour," + order;
        } else {
            url += '&sort=' + sort.columns + ',' + sort.order;
        }
        let params = [];
        params = this.pushParam(params, 'merchantCountry', merchantCountry);
        params = this.pushParam(params, 'company', company);
        params = this.pushParam(params, 'society', society);
        params = this.pushParam(params, 'store', store);
        params = this.pushParam(params, 'activity', activity);
        params = this.pushParam(params, 'status', status);
        params = this.pushParam(params, 'idTransaction', idTransaction);
        params = this.pushParam(params, 'idOrder', idOrder);
        params = this.pushParam(params, 'paymentMode', paymentMode);
        params = this.pushParam(params, 'paymentType', paymentType);
        params = this.pushParam(params, 'cardCategory', cardCategory);
        params = this.pushParam(params, 'cardType', cardType);
        params = this.pushDateParam(params, 'startDate', 'startHour', startDate);
        params = this.pushDateParam(params, 'endDate', 'endHour', endDate);
        params = this.pushDateParam(params, 'startSettDate', null, startSettDate);
        params = this.pushDateParam(params, 'endSettDate', null, endSettDate);
        params = this.pushParam(params, 'codeTypeTrsInterne', type);
        if (params.length > 0) {
            url += '&' + params.join("&");
        }
        return WebService.call(url, HttpMethods.GET, null)
    }

    getMinMaxSettDate(merchantCountry, company, society, store,
                      activity, status,
                      idTransaction, idOrder,
                      paymentMode, paymentType,
                      cardCategory, cardType,
                      startDate, endDate, type) {
        let url = '/api/transactions/settdates?';
        let params = [];
        params = this.pushParam(params, 'merchantCountry', merchantCountry);
        params = this.pushParam(params, 'company', company);
        params = this.pushParam(params, 'society', society);
        params = this.pushParam(params, 'store', store);
        params = this.pushParam(params, 'activity', activity);
        params = this.pushParam(params, 'status', status);
        params = this.pushParam(params, 'idTransaction', idTransaction);
        params = this.pushParam(params, 'idOrder', idOrder);
        params = this.pushParam(params, 'paymentMode', paymentMode);
        params = this.pushParam(params, 'paymentType', paymentType);
        params = this.pushParam(params, 'cardCategory', cardCategory);
        params = this.pushParam(params, 'cardType', cardType);
        params = this.pushDateParam(params, 'startDate', 'startHour', startDate);
        params = this.pushDateParam(params, 'endDate', 'endHour', endDate);
        params = this.pushParam(params, 'codeTypeTrsInterne', type);
        if (params.length > 0) {
            url += '&' + params.join("&");
        }
        return WebService.call(url, HttpMethods.GET, null)
    }

    getExport(page, size, sort,
              merchantCountry, company,
              society, store,
              activity, status,
              idTransaction, idOrder,
              paymentMode, paymentType,
              cardCategory, cardType,
              startDate, endDate,
              startSettDate, endSettDate,
              type,
              format, callback) {
        let language = getCookie('marketPayLanguage');
        let url = '/api/transactions/export?format=' + format + "&language=" + language + '&page=' + page + '&size=' + size;
        if (!sort.columns || sort.columns === 'DATE') {
            const order = sort.order ? sort.order : 'asc'
            url += "&sort=date," + order + "&sort=hour," + order;
        } else {
            url += '&sort=' + sort.columns + ',' + sort.order;
        }
        let params = [];
        params = this.pushParam(params, 'merchantCountry', merchantCountry);
        params = this.pushParam(params, 'company', company);
        params = this.pushParam(params, 'society', society);
        params = this.pushParam(params, 'store', store);
        params = this.pushParam(params, 'activity', activity);
        params = this.pushParam(params, 'status', status);
        params = this.pushParam(params, 'idTransaction', idTransaction);
        params = this.pushParam(params, 'idOrder', idOrder);
        params = this.pushParam(params, 'paymentMode', paymentMode);
        params = this.pushParam(params, 'paymentType', paymentType);
        params = this.pushParam(params, 'cardCategory', cardCategory);
        params = this.pushParam(params, 'cardType', cardType);
        params = this.pushParam(params, 'codeTypeTrsInterne', type);
        params = this.pushDateParam(params, 'startDate', 'startHour', startDate);
        params = this.pushDateParam(params, 'endDate', 'endHour', endDate);
        params = this.pushDateParam(params, 'startSettDate', null, startSettDate);
        params = this.pushDateParam(params, 'endSettDate', null, endSettDate);
        if (params.length > 0) {
            url += '&' + params.join("&");
        }
        WebService.downloadFile(url, HttpMethods.GET, function (blob, fileName) {
            FileSaver.saveAs(blob, fileName);
            callback(false);
        });
    }

    getTransactionCompanyList(merchantCountry) {
        let url = '/api/transactions/companies';
        let params = [];
        params = this.pushParam(params, 'merchantCountry', merchantCountry);
        if (params.length > 0) {
            url += '?' + params.join("&");
        }
        return WebService.call(url, HttpMethods.GET, null)
    }

    getTransactionAssociatedCompanyList(merchantCountry, store) {
        let url = '/api/transactions/associated/companies';
        let params = [];
        params = this.pushParam(params, 'merchantCountry', merchantCountry);
        params = this.pushParam(params, 'store', store);
        if (params.length > 0) {
            url += '?' + params.join("&");
        }
        return WebService.call(url, HttpMethods.GET, null)
    }

    getTransactionSocietyList(merchantCountry, company) {
        let url = '/api/transactions/societies';
        let params = [];
        params = this.pushParam(params, 'merchantCountry', merchantCountry);
        params = this.pushParam(params, 'company', company);
        if (params.length > 0) {
            url += '?' + params.join("&");
        }
        return WebService.call(url, HttpMethods.GET, null)
    }

    getTransactionAssociatedSocietyList(merchantCountry, store) {
        let url = '/api/transactions/associated/societies';
        let params = [];
        params = this.pushParam(params, 'merchantCountry', merchantCountry);
        params = this.pushParam(params, 'store', store);
        if (params.length > 0) {
            url += '?' + params.join("&");
        }
        return WebService.call(url, HttpMethods.GET, null)
    }

    getTransactionStoreList(merchantCountry, company, society) {
        let url = '/api/transactions/stores';
        let params = [];
        params = this.pushParam(params, 'merchantCountry', merchantCountry);
        params = this.pushParam(params, 'company', company);
        params = this.pushParam(params, 'society', society);
        if (params.length > 0) {
            url += '?' + params.join("&");
        }
        return WebService.call(url, HttpMethods.GET, null)
    }

    getTransactionCountryList() {
        let url = '/api/transactions/countries';
        return WebService.call(url, HttpMethods.GET, null)
    }

    getTransactionAssociatedCountryList(store) {
        let url = '/api/transactions/associated/countries?store='+store;
        return WebService.call(url, HttpMethods.GET, null)
    }

    getTransactionActivityList() {
        let url = '/api/transactions/activities';
        return WebService.call(url, HttpMethods.GET, null)
    }

    getTransactionStatusList() {
        let url = '/api/transactions/status';
        return WebService.call(url, HttpMethods.GET, null)
    }

    getTransactionPaymentTypeList() {
        let url = '/api/transactions/paymentTypes';
        return WebService.call(url, HttpMethods.GET, null)
    }

    getTransactionCardCategoryList() {
        let url = '/api/transactions/card-categories';
        return WebService.call(url, HttpMethods.GET, null)
    }

    getTransactionCardTypeList() {
        let url = '/api/transactions/card-types';
        return WebService.call(url, HttpMethods.GET, null)
    }

    getTransactionPaymentModeList() {
        let url = '/api/transactions/paymentModes';
        return WebService.call(url, HttpMethods.GET, null)
    }

    pushParam(params, key, value) {
        if (value !== null && value !== undefined) {
            if (value instanceof Date) {
                value = getFormattedDate(value);
            }
            if (Array.isArray(value) && value.length === 0) {
                return params;
            }
            params.push(key + '=' + value);
        }
        return params;
    }

    pushDateParam(params, keyDate, keyTime, value) {
        if (value !== null && value !== undefined && value instanceof Date) {
            const valueDate = getFormattedDate(value);
            const valueTime = getFormattedTime(value);
            params.push(keyDate + '=' + valueDate);
            if (keyTime) {
                params.push(keyTime + '=' + valueTime);
            }
        }
        return params;
    }

}

export default new TransactionService();


// WEBPACK FOOTER //
// ./src/services/TransactionService.js